import { FormattedMessage } from 'react-intl';

import { noop } from 'ui-components/default-props/noop';

import { MOVEMENT_INDICATORS } from './movement-indicators';
import { movementIndicator } from '../../../../../services/other-shipping-options/constants';

import { messages } from './messages';
import { SimpleDropdown } from '../../../../../components/simple-dropdown/index';

/**
 * @param {object} props
 * @param {string | null} props.optionData - identifier of the other option that we are managing with the dropdown
 * @param {(arg: { id: string, value: string|null }) => void} props.updateOption props.updateOption - callback to call when there is a change in the dropdown
 * @returns {JSX.Element} The rendered WindsorFrameworkMovementIndicatorDropdown
 */
export const WindsorFrameworkMovementIndicatorDropdown = ({ optionData = null, updateOption = noop }) => {
  const selectedOption = MOVEMENT_INDICATORS.find((option) => option.id === optionData);
  const optionsWithPlaceholder = [{ id: '', label: messages.emptyPlaceholderMovementType }, ...MOVEMENT_INDICATORS];
  const onChange = (value) => {
    updateOption({
      id: movementIndicator,
      value: value || null,
    });
  };
  return (
    <SimpleDropdown
      defaultTitle={<FormattedMessage {...messages.emptyPlaceholderMovementType} />}
      items={optionsWithPlaceholder.map((option) => ({
        key: option.id,
        name: <FormattedMessage {...option.label} />,
      }))}
      onItemSelected={onChange}
      selectedItemKey={selectedOption?.id}
    />
  );
};
